export default "__VITE_ASSET__Bs$rfHhW__"